module.exports = __webpack_public_path__ + "img/wywx.9c61e8d4.svg";